import { render, staticRenderFns } from "./documentLegalUsers.vue?vue&type=template&id=77b0af7f&"
import script from "./documentLegalUsers.vue?vue&type=script&lang=js&"
export * from "./documentLegalUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports